export default function toFaNumber(num) {

    try {
        if (typeof num === 'number' || typeof num === 'string') {
            num = num.toString()
        } else {
            return num
        }

        const persianDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];

        return num.replace(/\d/g, match => persianDigits[parseInt(match)]);

    } catch {
        return ''
    }

}


export function toFaNumberFormat(num) {


    try {
        return new Intl.NumberFormat('fa-IR', {}).format(num)
    } catch {
        return ''
    }
}


export function toEnglishDigits(str) {
    if (typeof str !== "string") return str;

    const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];

    const arabicDigits = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];


    for (let i = 0; i < 10; i++) {
        str = str.replace(new RegExp(persianDigits[i], 'g'), i)
            .replace(new RegExp(arabicDigits[i], 'g'), i);
    }

    return str;
}


export function formatMobileNumber(mobile) {

    if (typeof mobile !== 'string') {
        return mobile;
    }

    // maybe nationalCode
    if (mobile.length === 10) {
        return mobile
    }

    mobile = toEnglishDigits(mobile)
    // Remove non-digit characters
    mobile = mobile.replace(/\D/g, '');

    // If the number starts with "98", return as is
    if (mobile.startsWith("98")) {
        return mobile;
    }

    // If the number starts with "0", replace it with "98"
    if (mobile.startsWith("0")) {
        return "98" + mobile.substring(1);
    }

    // If the number starts with "9" (like "910..."), prepend "98"
    if (mobile.startsWith("9")) {
        return "98" + mobile;
    }

    // If none of the above cases match, return original
    return mobile;
}


export const formatPrice = (price) => {
    return new Intl.NumberFormat('fa-IR').format(price) + ' تومان';
};